import styled, { css } from 'styled-components';
import rem from 'polished/lib/helpers/rem';
// template components
import Col from '@nmx/template/dist/componentLibrary/foundations/Grid/Col';
import Picture from '@nmx/template/dist/componentLibrary/components/Picture';
import Typography from '@nmx/template/dist/componentLibrary/foundations/Typography';

export const ColStyledLeft = styled(Col)`
  ${({ theme }) => {
    const xlargeUp = theme.xlargeUp();
    const largeUp = theme.largeUp();
    const mediumUp = theme.mediumUp();
    let paddingRight = 0;

    if (xlargeUp) {
      paddingRight = rem(65);
    } else if (largeUp) {
      paddingRight = rem(40);
    } else if (mediumUp) {
      paddingRight = rem(30);
    }

    return css`
      ${mediumUp && `padding-right: ${paddingRight}`};
      display: ${mediumUp ? 'block' : 'flex'};
      ${!mediumUp && `
        align-items: center;
        flex-direction: column;
      `};
    `;
  }}
`;

export const ColStyledRight = styled(Col)`
  ${({ theme }) => {
    const mediumUp = theme.mediumUp();
    return css`
      display: ${mediumUp ? 'block' : 'none'};
    `;
  }}
`;

export const DivStyledMobileImageContainer = styled.div`
  ${({ theme }) => {
    const mediumUp = theme.mediumUp();
    return css`
      display: ${mediumUp ? 'none' : 'block'};
    `;
  }}
`;

export const FigureStyled = styled.figure`
  margin: 0;
`;

export const FigCaptionStyled = styled.figcaption`
  /** necessary for preventing horizontal scrolling with the assistive text chart data. something to look at potentially adding to our overall assistive text styles */
  width: ${rem(1)};
  height: ${rem(1)};
  overflow: hidden;
`;

export const PictureStyled = styled(Picture)`
  ${({ theme }) => {
    const mediumUp = theme.mediumUp();
    return css`
      height: auto;
      width: 100%;
      margin-bottom: ${mediumUp ? 0 : rem(32)};
      background-repeat: no-repeat;
      @media print {
        display: none !important;
      }
    `;
  }}
`;

export const TypographyStyled = styled(Typography)`
  ${({ theme }) => {
    const mediumUp = theme.mediumUp();
    return css`
      text-align: ${mediumUp ? 'left' : 'center'};
      padding-bottom: ${mediumUp ? rem(16) : rem(24)};
    `;
  }}
`;
